export const TEXT = {
header:{
    logo:"N",
    logoText:"NovaBank"
}, 

heroSection:{ 
heroTitle:"Banking made",
heroSubTitle:"Simple. Secure. Digital.",
features:{
featureTitle:["Secure Banking","Manage Accounts","24×7 Banking"],
 featureDescription:["Protect your money using enterprise-grade security."," Access all your savings accounts anytime."," Transfer money and perform banking whenever you need."],},
 },

register: { 
formTitle:"Create Your NovaBank Account",
 formSubTitle:"Register to access secure NetBanking services.",
 fullName:{label:"Full Name",placeholder:"Enter Full Name"},
 email:{label:"Email",placeholder:"Enter your email address"},
 mobile:{label:"Mobile Number",placeholder:"Enter mobile number"},
 password:{label:"Password",placeholder:"Create password"},
 confirmPassword:{label:"Confirm Password",placeholder:"Confirm Password"},
 
 createAccount:"Create Account",
 loginText:"Already have a NovaBank account?",
 loginBtn:"Login"
},

otpVerification:{
otpSuccessTitle:"Account Verified Successfully",
otpSuccessMessage:"Redirecting you to the login page...",
formTitle:"Verify Your Account",
formSubTtitle:"Enter the OTPs sent to your registered Email and Mobile Number.",
emailInfo:{emailLabel:"Email",emailOtpLabel:"Email OTP",},
smsInfo:{smsLabel:"Mobile",smsOtpLabel:"Mobile OTP",},
resendText:"Didn't receive the OTP?",
resendBtn:"Resend OTP",
verifyBtn:"Verify"
}
}